import { xLoginResponse } from "./login/loginresponsemodel";
import { ApiRequestModel } from "./api_request_model";
import { AppUserSettingInfoController } from "./login/loginrequestmodel";
import { environment } from "src/environments/environment";
import { CustomerAppSettings } from './CustomerAppSettings';

export class AppData {
  public cas: CustomerAppSettings;

  public static Instance(): AppData {
    if (this._instance == null)
      this._instance = new AppData();
    return this._instance;
  }

  private static _instance: AppData;

  public static GlobalApiUrl: string = environment.apiUrl.endsWith('/') ? environment.apiUrl : environment.apiUrl + '/';
    //public static GlobalApiUrl: string = 'http://healins.cloudapp.net/i1newapi/';
    //public static GlobalApiUrl: string = 'http://healins.cloudapp.net/aikyanewapi/';
    //public static GlobalApiUrl: string = 'http://healins.cloudapp.net/k1newapi/';
//public static GlobalApiUrl: string = 'http://40.76.72.202/ncsapi/';
//#endif
//public static GlobalApiUrl: string = 'http://192.168.137./NCSAPi/';
//public static GlobalApiUrl: string = 'http://192.168.43.213/NCSAPi/';
//public static GlobalApiUrl: string = 'http://192.168.1.8/NCSAPi/';
  
  public UserLoginDetails: xLoginResponse;
  public ApiRequestParms: ApiRequestModel;
    public AppUserSettingInfo: AppUserSettingInfoController;

    public GetDataParam(paramName: string): string {
        var returnval: string;

        var data = this.AppUserSettingInfo?.FacilityConfigParamController?.find(function (v, i, ary) {
          return v.ConfigParam === paramName;
        });

        returnval = (data == null || data.ConfigParamValue == null) ? '#' : data.ConfigParamValue;

        return returnval;
    }

//public SelectedStore: MaterialStore

  public CustomerUserId: string;
  public CustomerPassword: string;
  public static ActorImage: string;
  public static IsEncriptFromClientSide: boolean = true;
  public SelectedBranchName: string;
  public SelectedBranchCode: number;
    public SelectedFacilityName: string;
    public SelectedRoleName: string;
  public SelectedFacilityCode: number;


  public IsSessionExits: boolean;

  public static CanAdjustgetTimezoneOffset: boolean = true;



}
